import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import cs from 'classnames';

import mapDispatch from '~/misc/mapDispatch';
import { modalChange } from '~/modules/modal/actions';

import css from './style.css';

const timeDiff = (start, end) => (start - end) / 1000 / 60 / 60;
const localStrKey = 'upgradeEntrance';

class UpgradeEntrance extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    const userIsLoggedIn = user && user.id && user.token;
    const userIsLogging = user && !user.id && user.token;
    const userNotLoging = user && !user.id && !user.token;
    if (userIsLogging) {
      this.state = { showEntrance: false };
    }
    const setTime = window && window.localStorage && window.localStorage.getItem(localStrKey);
    let showEntrance = false;
    if (userNotLoging) {
      if (setTime) {
        showEntrance = timeDiff(new Date().getTime(), setTime) > 48;
      } else {
        showEntrance = true;
      }
      this.state = { showEntrance };
    }
    if (userIsLoggedIn) {
      const { accountLevel, standard } = this.props.account;
      if (setTime) {
        showEntrance =
          timeDiff(new Date().getTime(), setTime) > 48 &&
          parseInt(accountLevel) < parseInt(standard);
      } else {
        showEntrance = parseInt(accountLevel) < parseInt(standard);
      }
      this.state = { showEntrance };
    }
  }
  componentWillReceiveProps(nextProps) {
    const { accountLevel, standard } = this.props.account;
    const { accountLevel: newAccountLevel } = nextProps.account;
    const { user } = nextProps;
    // membership no change
    if (accountLevel === newAccountLevel) return;
    // user is logging
    if (user && !user.id && user.token) return;
    const setTime = window && window.localStorage && window.localStorage.getItem(localStrKey);
    let showEntrance = false;
    if (user && user.id && user.token) {
      if (setTime) {
        showEntrance =
          timeDiff(new Date().getTime(), setTime) > 48 &&
          parseInt(newAccountLevel) < parseInt(standard);
      } else {
        showEntrance = parseInt(newAccountLevel) < parseInt(standard);
      }
      this.state = { showEntrance };
    }
    if (user && !user.id && !user.token) {
      if (setTime) {
        showEntrance = timeDiff(new Date().getTime(), setTime) > 48;
      } else {
        showEntrance = true;
      }
      this.state = { showEntrance };
    }
  }
  gotoManagePlan() {
    if (!this.props.user || !this.props.user.isLoggedIn) {
      this.props.showLogIn();
      return;
    }
    const source =
      window.location && window.location.href && window.location.href.indexOf('search') >= 0
        ? 'loads_search_list_advertisement'
        : 'loads_search_advertisement';
    browserHistory.push(`/hp?from=${source}&level=premium`);
  }
  closeEntrance() {
    if (window.localStorage) {
      window.localStorage.setItem(localStrKey, new Date().getTime());
    }
    this.setState({ showEntrance: false });
  }
  render() {
    const { showEntrance } = this.state;
    if (!showEntrance) return null;
    return (
      <section className={cs(css.upgradeEntrance, 'wide')}>
        <div className={css.container}>
          <div className={css.entranText}>
            <div>Maximize your earnings</div>
            <div>Acesss freight rates in all your search results, compare the market averages vs. what the broker is advertising</div>
            {/* <div>Access broker's credit score and days-to-pay</div> */}
            <div>Identify hot markets to haul with our capacity tool that shows the load vs truck index in regions across USA</div>
            {/* You are one step away from getting unlimited access to 150,000+ high paying loads daily.
            Find available freight faster than ever on Truckloads! */}
          </div>
          <div className={css.entranbtn} onClick={() => this.gotoManagePlan()}>
            Subscribe!
          </div>
          <div className={css.closeBtn} onClick={() => this.closeEntrance()}>
            <img src='/assets/close-white.svg' alt='' />
          </div>
        </div>
        <div className={css.mobileContainer}>
          <div className={css.mobileEntranText}>
            <div>Maximize your earnings</div>
            <div>by identifying hot markets to haul with our capacity tool that shows the load vs truck index across the States</div>
          </div>
          <div className={css.mobileEntranbtn} onClick={() => this.gotoManagePlan()}>
            Subscribe!
          </div>
          <div className={css.mobileCloseBtn} onClick={() => this.closeEntrance()}>
            <img src='/assets/close-white.svg' alt='' />
          </div>
        </div>
      </section>
    );
  }
}

export default connect(
  ({ user, account }) => ({ user, account }),
  mapDispatch({ showLogIn: () => modalChange('login', 'rate-check') })
)(UpgradeEntrance);



// WEBPACK FOOTER //
// ./src/pages/MembershipPlans/components/UpgradeEntrance/index.js